"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableHeaderCell = exports.SortDirection = exports.TableCell = exports.TableRow = exports.TableFoot = exports.TableBody = exports.TableHead = exports.Table = void 0;
var react_1 = __importDefault(require("react"));
exports.Table = function (props) {
    var className = props.className, headBorder = props.headBorder, bottomBorder = props.bottomBorder, lined = props.lined, ruled = props.ruled, innerGrid = props.innerGrid, grid = props.grid, framed = props.framed, barred = props.barred, striped = props.striped, chequered = props.chequered, paddedTable = props.paddedTable, paddedCells = props.paddedCells, selectableRows = props.selectableRows, tableProps = __rest(props, ["className", "headBorder", "bottomBorder", "lined", "ruled", "innerGrid", "grid", "framed", "barred", "striped", "chequered", "paddedTable", "paddedCells", "selectableRows"]);
    var tableClasses = ["c-table"];
    if (props.headBorder) {
        tableClasses.push("+head-border");
    }
    if (props.bottomBorder) {
        tableClasses.push("+bottom-border");
    }
    if (props.lined) {
        tableClasses.push("+lined");
    }
    if (props.ruled) {
        tableClasses.push("+ruled");
    }
    if (props.innerGrid) {
        tableClasses.push("+inner-grid");
    }
    if (props.grid) {
        tableClasses.push("+grid");
    }
    if (props.framed) {
        tableClasses.push("+frame");
    }
    if (props.barred) {
        tableClasses.push("+bars");
    }
    if (props.striped) {
        tableClasses.push("+stripes");
    }
    if (props.chequered) {
        tableClasses.push("+chequered");
    }
    if (props.paddedTable) {
        tableClasses.push("+padded-table");
    }
    if (props.paddedCells) {
        tableClasses.push("+padded-cells");
    }
    if (props.selectableRows) {
        tableClasses.push("+selectable-rows");
    }
    if (className) {
        tableClasses.push(className);
    }
    return react_1.default.createElement("table", __assign({ className: "" + tableClasses.join(" ") }, tableProps));
};
exports.TableHead = function (props) {
    return react_1.default.createElement("thead", __assign({}, props));
};
exports.TableBody = function (props) {
    return react_1.default.createElement("tbody", __assign({}, props));
};
exports.TableFoot = function (props) {
    return react_1.default.createElement("tfoot", __assign({}, props));
};
exports.TableRow = function (props) {
    var className = props.className, selected = props.selected, trProps = __rest(props, ["className", "selected"]);
    var trClasses = ["c-table__row"];
    if (selected) {
        trClasses.push("+selected");
    }
    if (className) {
        trClasses.push(className);
    }
    return react_1.default.createElement("tr", __assign({}, trProps, { className: trClasses.join(" ") }));
};
exports.TableCell = function (props) {
    var className = props.className, header = props.header, numerical = props.numerical, tight = props.tight, primary = props.primary, priority = props.priority, tdProps = __rest(props, ["className", "header", "numerical", "tight", "primary", "priority"]);
    var TagName = header ? "th" : "td";
    var tdClasses = ["c-table__cell"];
    if (props.numerical) {
        tdClasses.push("+numerical");
    }
    if (props.tight) {
        tdClasses.push("+tight");
    }
    if (props.primary) {
        tdClasses.push("+primary");
    }
    if (props.priority) {
        tdClasses.push("+priority");
    }
    if (className) {
        tdClasses.push(className);
    }
    return react_1.default.createElement(TagName, __assign({ className: "" + tdClasses.join(" ") }, tdProps));
};
var SortDirection;
(function (SortDirection) {
    SortDirection["Ascending"] = "Ascending";
    SortDirection["Descending"] = "Descending";
})(SortDirection = exports.SortDirection || (exports.SortDirection = {}));
exports.TableHeaderCell = function (props) {
    var className = props.className, sortable = props.sortable, sortDirection = props.sortDirection, thProps = __rest(props, ["className", "sortable", "sortDirection"]);
    // `c-cell` is supplied by the TableData component
    var thClasses = [];
    if (props.sortable) {
        thClasses.push("+sortable");
    }
    if (props.sortDirection) {
        thClasses.push("+sorted");
        if (props.sortDirection === SortDirection.Descending) {
            thClasses.push("+up");
        }
    }
    if (className) {
        thClasses.push(className);
    }
    return react_1.default.createElement(exports.TableCell, __assign({}, thProps, { className: "" + thClasses.join(" "), header: true }));
};
exports.Table.Head = exports.TableHead;
exports.Table.Body = exports.TableBody;
exports.Table.Foot = exports.TableFoot;
exports.Table.HeaderCell = exports.TableHeaderCell;
exports.Table.Cell = exports.TableCell;
exports.Table.Row = exports.TableRow;
//# sourceMappingURL=Table.js.map